import { Auth, AuthOptions } from "@rscollabs/rs-ui-auth";
import router from "../../router";
import rs_kakao from "@/config/rs_kakao";
import { getCurrentEnv, SUPPORT_ENV } from "@/utils/util";

let config: any  = 'dev';
const env: any = getCurrentEnv();

if (env === SUPPORT_ENV.prod) {
  config = rs_kakao.prod;
} else if (env === SUPPORT_ENV.qa) {
  config = rs_kakao.qa;
} else {
  config = rs_kakao.dev;
}

const buildAuthConfig = () => {
  const authConfig: AuthOptions = {
    sigil: {
      idTokenCookie: config?.idTokenCookie || "sigil_id_token",
      accessTokenCookie: config?.accessTokenCookie || "sigil_access_token",
      loginUrl: config?.sigilUrl,
      logoutUrl: config?.legacyHomePage
    }
  };

  if (config?.auth0) {
    authConfig.auth0 = {
      clientOptions: {
        domain: config.auth0.domain,
        clientId: config.auth0.clientId,
        authorizationParams: {
          redirect_uri: config.auth0.redirectUri,
          audience: config.auth0.audience
        },
        cacheLocation: "localstorage"
      },
      // You can enable the redirect to use, for example, your client app router here
      redirectCallback: (target: any) => {
        router.push(target);
      }
    };
  }
  return authConfig;
};

export const auth = new Auth(buildAuthConfig());
